require('./RASetGoalStep2.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const { AmountInput } = require('commonsComponents/amountInput');
const { OKDatePicker } = require('commonsComponents/OKDatePicker');
const BrokerEditAlias = require('components/commons/broker/brokerEditAlias/brokerEditAlias');
const RAImageButton = require('../../commons/RAImageButton/RAImageButton');

// @components
const RASetGoalStepHeader = require('../RASetGoalStepHeader/RASetGoalStepHeader');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getLanguage } = require('core/i18n').i18n;

// @constants
const {
    EURO_SYMBOL,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_ROBO_EDIT_FIELD_FONT,
} = require('constants/index');
const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_DATE_FORMAT,
    DATE_PICKER_CUSTOM_LOCALE,
} = require('constants/commonsComponents');
const {
    RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT,
} = require('../../../raConstants/index');

class RASetGoalStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            titleEditor: false,
        };
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleTitleFocus = this.handleTitleFocus.bind(this);
        this.handleTitleBlur = this.handleTitleBlur.bind(this);
    }

    handleTitleChange(e) {
        this.props.onTitleChange(e);
    }

    handleTitleFocus() {
        this.setState({
            titleEditor: true,
        });
    }

    handleTitleBlur(e) {
        this.props.onTitleChange(e);
        this.setState({
            titleEditor: false,
        });
    }

    buildAmountSection() {
        const {
            immSteps,
            onInvestmentAmountChange,
            errorState,
            errorMsg,
        } = this.props;
        const investmentAmount = immSteps.getIn([
            SECOND_STEP,
            'investmentAmount',
        ]);

        return (
            <div className="ra-set-goal-step2__section-amount">
                <AmountInput
                    amount={investmentAmount}
                    callback={onInvestmentAmountChange}
                    max={RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT}
                    min={0}
                    error={errorState}
                    errorMsg={errorMsg}
                    name={name}
                    language={getLanguage()}
                    hideFocusZero={true}
                />
                <span className="ra-set-goal-step2__currency">
                    {EURO_SYMBOL}
                </span>
            </div>
        );
    }

    buildCustomCalender() {
        const { onDateChange, immSteps } = this.props;
        const investmentDate = immSteps.getIn([SECOND_STEP, 'investmentDate']);
        const dateLabel = formatText('raSetGoal-calenderText');
        const minDate = immSteps.getIn([SECOND_STEP, 'minDate']);
        const maxDate = immSteps.getIn([SECOND_STEP, 'maxDate']);

        return (
            <div className="ra-set-goal-step2__container--block-calendar">
                <div className="ra-set-goal-step2__container--block-calendar-label">
                    {dateLabel}
                </div>
                <div key={investmentDate === null}>
                    <OKDatePicker
                        locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                        callback={onDateChange}
                        callbackError={this.props.onDatePickerError} // eslint-disable-line
                        selectedDate={investmentDate}
                        newSelectedDate={investmentDate}
                        placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        startDate={minDate}
                        minDate={minDate}
                        maxDate={maxDate}
                        messageStandardErrorDate={formatText(
                            'raDatePicker-raDatePicker_standardDateError',
                        )}
                        messageLessThanMinDateError={formatText(
                            'raDatePicker-raDatePicker_lessThanMinDateError',
                        )}
                        messageMoreThanMinDateError={formatText(
                            'raDatePicker-raDatePicker_moreThanMaxDateError',
                        )}
                        defaultPlaceholder={formatText(
                            'datePickerCustom-defaultPlaceholder',
                        )}
                        defaultPlaceholderDay={formatText(
                            'datePickerCustom-defaultPlaceholderDay',
                        )}
                        defaultPlaceholderMonth={formatText(
                            'datePickerCustom-defaultPlaceholderMonth',
                        )}
                        defaultPlaceholderYear={formatText(
                            'datePickerCustom-defaultPlaceholderYear',
                        )}
                    />
                </div>
            </div>
        );
    }

    buildInvestmentContent() {
        const {
            immSteps,
            onTitleChange,
            extraClass,
            namesHistory,
        } = this.props;
        const investmentTitle = immSteps.getIn([
            SECOND_STEP,
            'investmentTitle',
        ]);
        const goals = immSteps.getIn([FIRST_STEP, 'goals']);
        const goalSelected = immSteps.getIn([FIRST_STEP, 'goalSelected']);
        const selectedGoal = goals.find(goal => {
            return goal.get('isSelected') === true;
        });
        const iconType =
            goalSelected && selectedGoal ? selectedGoal.get('id') : '';
        // add flag icon
        const extraContent = !goalSelected ? (
            <i className="icon-nuevos-objetivos icon ra-set-goal-step2__goal-icon" />
        ) : null;
        const extraClassForGoalWrapper = classnames(extraClass, {
            'ra-set-goal-step2__goal-icon--small': iconType == '',
        });
        const nameError =
            namesHistory &&
            namesHistory.some(
                names => names.toLowerCase() === investmentTitle.toLowerCase(),
            );
        const emptyNameError = investmentTitle === '' && goalSelected;
        let errorMessage = 'raManagementPlan-raManagementPlan_customNameError';
        if (emptyNameError) {
            errorMessage =
                'raManagementPlan-raManagementPlan_customNameEmptyError';
        }

        return (
            <div className="ra-set-goal-step2__section-invest">
                <RAImageButton
                    extraClass="ra-set-goal-step2__section-invest--goal-icon"
                    extraContent={extraContent}
                    iconType={iconType}
                    isSelected={true}
                    size="small"
                    extraClassForGoalWrapper={extraClassForGoalWrapper}
                />
                <h1 className="profile-picture-editor__alias-edit ra-set-goal-step2__placeholder">
                    <BrokerEditAlias
                        alias={investmentTitle}
                        aliasPlaceHolder={formatText(
                            'raManagementPlan-raManagementPlan_objectiveNamePlaceholder',
                        )}
                        allowEmptyAlias={true}
                        allowMaxLength={true}
                        limit={50}
                        postAlias={onTitleChange}
                        fontSize={BROKER_ROBO_EDIT_FIELD_FONT}
                        error={nameError || emptyNameError}
                        errorMessage={formatText(errorMessage)}
                    />
                </h1>
            </div>
        );
    }

    render() {
        const { disabled, isValid } = this.props;
        const amountSectionBlock = this.buildAmountSection();
        const calenderSectionBlock = this.buildCustomCalender();
        const iconInvestmentSectionBlock = this.buildInvestmentContent();
        const className = classnames('ra-set-goal-step2', {
            'ra-set-goal-step2__disabled': !disabled,
        });

        return (
            <div className={className}>
                <RASetGoalStepHeader
                    title={formatText('raSetGoal-step2HeaderTitle')}
                    description={formatText('raSetGoal-step2HeaderDescription')}
                    active={isValid}
                />
                <div className="ra-set-goal-step2__container">
                    {iconInvestmentSectionBlock}
                    <div className="row ra-set-goal-step2__container--block">
                        <div className="col-md-4">
                            <div className="ra-set-goal-step2__header-invest">
                                <FormattedText
                                    value="raSetGoal-goalAmountTitle"
                                    className="ra-set-goal-step2__text ra-set-goal-step2__text--active"
                                />
                            </div>
                            <div>{amountSectionBlock}</div>
                        </div>
                        <div className="col-md-6">{calenderSectionBlock}</div>
                    </div>
                </div>
            </div>
        );
    }
}

RASetGoalStep2.propTypes = {
    immSteps: PropTypes.object.isRequired,
    isValid: PropTypes.bool.isRequired,
    namesHistory: PropTypes.object.isRequired,
    onDateChange: PropTypes.func.isRequired,
    onDatePickerError: PropTypes.func,
    onInvestmentAmountChange: PropTypes.func.isRequired,
    onTitleChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    errorState: PropTypes.bool,
    errorMsg: PropTypes.string,
    extraClass: PropTypes.string,
};

module.exports = RASetGoalStep2;
